import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { makeStyles } from "@mui/styles";
import { Box, Card, Grid, Stack, TableContainer, Typography } from "@mui/material";
import TablePagination from "@mui/material/TablePagination";
import { useState } from "react";
import EditPropertyIcon from "../../icons/EditPropertyIcon.svg";
import RemovePropertyIcon from "../../icons/RemovePropertyIcon.svg";
import { getPropertiesData, selectProperties, selectPropertiesCurrentPage, selectPropertiesState } from "./sagas/pmPropertiesSlice";
import { useDispatch, useSelector } from "react-redux";
import TableHeader from "../shared/TableHeader";
import SpinnerWithNoConfirmation from "../../shared/Modal/spinnerWithNoConfirmation";
import BadRequestIcon from "../../icons/Badrequesterror.svg";
import Error500 from "../../icons/505Error.svg";

const useStyles = makeStyles({
  gridContainer: {
    background: "#FFFFFF",
    borderRadius: "24px",
  },
});

const optionValues = [
  {
    key: "PropertyName",
    value: "Property Name",
  },
  {
    key: "PropertyId",
    value: "Property ID",
  },
  {
    key: "City",
    value: "City",
  },
  {
    key: "State",
    value: "State",
  },
  {
    key: "Zip",
    value: "Zip Code",
  },
];

export default function Properties() {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [currentPage, setCurrentPage] = React.useState(0);
  const [recordStartIndex, setRecordStartIndex] = useState(0);
  const [rangeSize, setRangeSize] = useState(100);
  const [searchField, setSearchField] = React.useState("");
  const [searchValue, setSearchValue] = React.useState("");
  const [isSearchValueEmpty, setIsSearchValueEmpty] = React.useState(false);
  const columnsSelectRef = React.createRef<HTMLSelectElement>();
  const [columnFilterSearchField, setColumnFilterSearchField] = React.useState("");
  const [searchChipOpen, setSearchChipOpen] = React.useState(false);
  const searchValueInputRef = React.createRef<HTMLInputElement>();
  const [searchBluePillValue, setSearchPillValue] = React.useState("");
  const propertiesData = useSelector(selectProperties);
  const propertiesDataState = useSelector(selectPropertiesState)
  let propertiesDataBook = useSelector(selectPropertiesCurrentPage);
  const setSearchPageIndex = (pageNumber: number) => {
    if (!propertiesDataBook[pageNumber]) {
      const newIndex = pageNumber * rangeSize;
      setRecordStartIndex(newIndex);
    }
  };
  const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, newPageNumber: number) => {
    setSearchPageIndex(newPageNumber);
    setCurrentPage(newPageNumber);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setCurrentPage(0);
    setRecordStartIndex(0);
    setRangeSize(parseInt(event.target.value));
  };
  const searchValueChangeHandler = (e: any) => {
    setSearchValue(e.target.value ? e.target.value.trim() : '');
  };
  const searchFieldChangeHandler = (e: any) => {
    setSearchField(e.target.value);
  };
  const handleChooseColumnSearchField = (event: any) => {
    event.preventDefault();
    if (columnsSelectRef?.current) {
      setColumnFilterSearchField(columnsSelectRef?.current?.value);
    }
  };
  React.useEffect(() => {
    if (searchValue.length === 0) {
      setIsSearchValueEmpty(true);
    } else {
      setIsSearchValueEmpty(false);
    }
  }, [searchValue]);

  React.useEffect(() => {
    dispatch(
      getPropertiesData({
        RangeSize: rangeSize,
        StartIndex: recordStartIndex,
      })
    );
  }, [dispatch, rangeSize, recordStartIndex]);

  const resetTableRows = () => {
    setSearchChipOpen(false);
    setSearchValue("");
    setSearchField("");
    setSearchPillValue("");
    dispatch(
      getPropertiesData({
        RangeSize: rangeSize,
        StartIndex: 0,
      })
    );
  };

  const searchProperties = (event: any) => {
    setCurrentPage(0);
    setSearchChipOpen(true);
    event.preventDefault();
    if (searchValueInputRef?.current && searchValueInputRef?.current?.value?.length !== 0) {
      setSearchPillValue(searchValueInputRef?.current?.value);
    }
    if (searchValueInputRef?.current?.value?.length !== 0) {
      dispatch(
        getPropertiesData({
          RangeSize: rangeSize,
          StartIndex: 0,
          SearchField: searchField,
          SearchValue: searchValue,
        })
      );
    }
  };

  return (
    <Grid item xs={12} sx={{ mt: 3.5 }}>
      <Card sx={{ p: 2, display: "flex", flexDirection: "column", height: 'calc( 100vh - 144px )', pb: '64px' }} className={classes.gridContainer} style={{ position: "relative" }}>
        <React.Fragment>
          <Box sx={{ display: "flex", p: 1, pb: 2, justifyContent: "flex-start", "& .MuiTextField-root": { m: 1, width: "25ch" } }}>
            <TableHeader
              searchValueChangeHandler={searchValueChangeHandler}
              searchValue={searchValue}
              isSearchValueEmpty={isSearchValueEmpty}
              searchFieldChangeHandler={searchFieldChangeHandler}
              searchField={searchField}
              optionValues={optionValues}
              handleSearch={searchProperties}
              columnsSelectRef={columnsSelectRef}
              handleChooseColumnSearchField={handleChooseColumnSearchField}
              resetTableRows={resetTableRows}
              setSearchChipOpen={setSearchChipOpen}
              searchChipOpen={searchChipOpen}
              resetSearchFilter={setSearchField}
              resetSearchValue={setSearchValue}
              columnFilterSearchField={columnFilterSearchField}
              searchBluePillValue={searchBluePillValue}
              searchValueInputRef={searchValueInputRef}
              rangeSize={rangeSize}
              recordStartIndex={recordStartIndex}
              hideCalendarIcon={true}
              hideDateRangeSearchPillChip={true}
              hideCalendarModal={true}
            />
          </Box>
          {
            String(propertiesDataState.errorMessage.statusCode)[0] === '4' ?
              <Grid container direction="row" spacing={2} alignItems="center" justifyContent='center' sx={{ height: '100vh' }} >
                <Grid item display="flex" flexDirection="column" alignItems='center'>
                  <Grid item display="flex" justifyContent='center' pb={3} mt={3}>
                    <img src={BadRequestIcon} alt='400' />
                  </Grid>
                  <Grid item justifyContent='center'>
                    <Typography
                      sx={{
                        fontFamily: "Work Sans",
                        fontStyle: 'normal',
                        fontWeight: 700,
                        fontSize: '40px',
                        lineHeight: '23px',
                        color: '#2E82AF',
                        textAlign: 'center',
                        marginTop: '10px'
                      }}>
                      {
                        propertiesDataState.errorMessage.statusCode
                      }
                    </Typography>
                  </Grid>
                  <Grid mt={2} item justifyContent='center'>
                    <Typography
                      sx={{
                        fontFamily: "Work Sans",
                        fontStyle: 'normal',
                        fontWeight: 400,
                        fontSize: '20px',
                        lineHeight: '23px',
                        color: '#9E9E9E',
                        textAlign: 'center',
                        marginTop: '10px'
                      }}>
                      Page not found.
                    </Typography>
                  </Grid>
                  <Grid item justifyContent='center' mt={2} xs={8}>
                    <Typography
                      sx={{
                        fontFamily: "Work Sans",
                        fontStyle: 'normal',
                        fontWeight: 400,
                        fontSize: '14px',
                        lineHeight: '23px',
                        color: '#9E9E9E',
                        textAlign: 'center',
                        marginTop: '10px',
                      }}>
                      {propertiesDataState.errorMessage.message.length === 0 ? '' : propertiesDataState.errorMessage.message}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              : String(propertiesDataState.errorMessage.statusCode)[0] === '5' ?
                <Grid container direction="row" spacing={2} alignItems="center" justifyContent='center' sx={{ height: '100vh' }} >
                  <Grid item display="flex" flexDirection="column" alignItems='center'>
                    <Grid item display="flex" justifyContent='center' sx={{ marginLeft: '5%' }} >
                      <img src={Error500} alt='500' style={{ height: '35vh' }} />
                    </Grid>
                    <Grid item justifyContent='center'>
                      <Typography
                        sx={{
                          fontFamily: "Work Sans",
                          fontStyle: 'normal',
                          fontWeight: 700,
                          fontSize: '40px',
                          lineHeight: '23px',
                          color: '#2E82AF',
                          textAlign: 'center',
                          marginTop: '10px'
                        }}>
                        {
                          propertiesDataState.errorMessage.statusCode
                        }
                      </Typography>
                    </Grid>
                    <Grid mt={2} item justifyContent='center'>
                      <Typography
                        sx={{
                          fontFamily: "Work Sans",
                          fontStyle: 'normal',
                          fontWeight: 400,
                          fontSize: '20px',
                          lineHeight: '23px',
                          color: '#9E9E9E',
                          textAlign: 'center',
                          marginTop: '10px'
                        }}>
                        Page not found.
                      </Typography>
                    </Grid>
                    <Grid item justifyContent='center' mt={2} xs={8}>
                      <Typography
                        sx={{
                          fontFamily: "Work Sans",
                          fontStyle: 'normal',
                          fontWeight: 400,
                          fontSize: '14px',
                          lineHeight: '23px',
                          color: '#9E9E9E',
                          textAlign: 'center',
                          marginTop: '10px',
                        }}>
                        {propertiesDataState.errorMessage.message.length === 0 ? '' : propertiesDataState.errorMessage.message}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid> :
                propertiesDataState.isFetchingProperties ? (
                  <Stack
                    justifyContent="center"
                    alignItems="center"
                    style={{
                      height: "1100px",
                    }}
                  >
                    <SpinnerWithNoConfirmation />
                  </Stack>
                )
                  :
                  <TableContainer style={{ flex: 1 }}>
                    <Table size="small" stickyHeader>
                      <TableHead>
                        <TableRow>
                          <TableCell id="subTitle">Property</TableCell>
                          <TableCell id="subTitle">Property ID</TableCell>
                          <TableCell id="subTitle">City</TableCell>
                          <TableCell id="subTitle">State</TableCell>
                          <TableCell id="subTitle">Zip</TableCell>
                          <TableCell id="subTitle">
                            <Stack direction="row" justifyContent="center" alignItems="center" spacing={1}>
                              Edit
                            </Stack>
                          </TableCell>
                          <TableCell id="subTitle">
                            <Stack direction="row" justifyContent="center" alignItems="center" spacing={1}>
                              Remove
                            </Stack>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody style={{ left: "28px" }}>
                        {propertiesDataBook?.[currentPage] &&
                          propertiesDataBook?.[currentPage].Rows?.map((eachRow) => {
                            return (
                              <TableRow key={eachRow.Uuid}>
                                <TableCell id="content">{eachRow && eachRow?.Name}</TableCell>
                                <TableCell id="content">{eachRow?.ExternalRefId2}</TableCell>
                                <TableCell id="content">{eachRow?.PhysicalAddress?.City}</TableCell>
                                <TableCell id="content">{eachRow?.PhysicalAddress?.State}</TableCell>
                                <TableCell id="content">{eachRow?.PhysicalAddress?.Zip}</TableCell>
                                <TableCell id="content">
                                  <Stack direction="row" justifyContent="center" alignItems="center" spacing={1}>
                                    <img src={EditPropertyIcon} alt="Edit property" style={{ cursor: "pointer" }} />
                                  </Stack>
                                </TableCell>
                                <TableCell id="content">
                                  <Stack direction="row" justifyContent="center" alignItems="center" spacing={1}>
                                    <img src={RemovePropertyIcon} alt="remove property" style={{ cursor: "pointer" }} />
                                  </Stack>
                                </TableCell>
                              </TableRow>
                            );
                          })}
                      </TableBody>
                    </Table>
                  </TableContainer>
          }
          <TablePagination component="div" rowsPerPageOptions={[50, 100, 200]} count={propertiesData?.TotalCount} page={currentPage} onPageChange={handleChangePage} rowsPerPage={rangeSize} onRowsPerPageChange={handleChangeRowsPerPage} sx={{ position: 'absolute', bottom: 10, right: 10 }} />
        </React.Fragment>
      </Card>
    </Grid>
  );
}
